module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/chicken-star3.9ef4040c.png";